import React from "react";
import { useNavigate, useLocation } from "react-router-dom";  // 添加 useLocation

export default function Header () {
    const navigate = useNavigate();
    const location = useLocation();  // 获取当前路径

    function goHome() {
        navigate('/');
    }

    // 判断是否是首页（路径为 '/'）
    const isHomePage = location.pathname === '/';

    return (
        <header id="header">
            <span className="header-btn-left iconfont icon-fanhui2" onClick={goHome}></span>
            <span className="header-btn-right iconfont icon-yonghu"></span>
        </header>
    );
}